import { render, staticRenderFns } from "./SimplifiedContainer.vue?vue&type=template&id=220ac25c"
import script from "./SimplifiedContainer.vue?vue&type=script&lang=js"
export * from "./SimplifiedContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports